<template>
  <div class="esm-item-input">
    <div class="form-group row">
      <div class="col-sm-12">
        <draggable v-model="valArray" @end="validate(valArray)">
          <div v-for="(val, index) in valArray" :key="index">
            <div class="card mb-3">
              <accordian-display
              :defaultOpen="true"
              :draggable="true"
              :title="'ESM Item ' + parseInt(index + 1)"
              :icon="'fa fa-fw fa-table'">
                <div class="card-body text-dark">
                  <div class="row">
                    <div class="col-12">
                      <esm-item-form
                        :val="val"
                        :index="index"
                        :existing="val.existing || existing"
                        v-model="value[index]">
                      </esm-item-form>
                    </div>
                  </div>
                </div>
              </accordian-display>
              <div class="card-footer text-right">
                <button
                  @click.prevent="clearDate(val)"
                  class="my-1 btn btn-info">
                  <i class="fa fa-calendar-times"></i> Clear Date
                </button>
                <button
                  @click.prevent="duplicateItem(val)"
                  class="my-1 btn btn-info">
                  <i class="fa fa-copy"></i> Duplicate
                </button>
                <button
                  @click.prevent="deleteItem(val)"
                  class="my-1 btn btn-danger">
                  <i class="fa fa-trash"></i> Delete
                </button>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="col-sm-12">
        <button class="btn btn-info upload-button" type="button" @click.prevent="addNewItem()">
          <i class="fa fa-plus"></i> New Personnel Details
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Draggable from 'vuedraggable'
  import Api from '@/vuex/api'
  import AccordianDisplay from '@/components/displays/AccordianDisplay'
  import EsmItemForm from '@/components/displays/EsmItemForm'
  import {
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'EsmItemInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      AccordianDisplay,
      Draggable,
      EsmItemForm
    },
    data () {
      return {
        isDirty: false,
        isValid: false,
        existing: [],
        valArray: []
      }
    },
    computed: {
      validationClass,
      validationMessage
    },
    async mounted () {
      this.valArray = this.value
      let instance = new Api()
      let esmItems = await instance.getEsmItems()
      this.existing = esmItems
    },
    methods: {
      validate (val = this.value) {
        this.$emit('input', val)
        this.isDirty = true
        if (Array.isArray(val) && val.length) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      deleteItem (val) {
        let values = this.value
        values.splice(values.indexOf(val), 1)
        this.$emit('input', values)
      },
      duplicateItem (val) {
        let values = this.value
        let newVal = Object.assign({}, val)
        newVal.added = (Math.random() + 1).toString(36).substring(7)
        values.push(newVal)
        this.$emit('input', values)
      },
      clearDate (val) {
        let values = this.value
        let newVal = Object.assign({}, val)
        newVal.lastTested = null
        values.splice(values.indexOf(val), 1, newVal)
        this.$emit('input', values)
      },
      moveUp (index) {
        let values = this.value
        values.splice(index - 1, 0, values.splice(index, 1)[0])
        this.$emit('input', values)
      },
      moveDown (index) {
        let values = this.value
        values.splice(index + 1, 0, values.splice(index, 1)[0])
        this.$emit('input', values)
      },
      addNewItem () {
        let values = this.value
        values.push({
          item: '',
          address: '150 Sydney Road, Coburg VIC, 3058',
          companyName: 'Roscon',
          finding: '',
          status: '1',
          lastTested: null,
          added: (Math.random() + 1).toString(36).substring(7)
        })
        this.$emit('input', values)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/EsmItemInput.vue